import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">        
        <p>
          Política de Privacidade
        </p>      
      </header>
      <main>
        <h2>Aplicativo Mês Bíblico</h2>
        <div>
          <p className='topic'>Política de Privacidade</p>
          <div className='text'>
            <p> A sua privacidade é importante para nós. Não solicitamos informações pessoais, mas caso venhamos futuramente a fazê-lo será por meios justos e legais, com o seu conhecimento e consentimento.</p>
            <p>Algumas informações são coletadas com o objetivo de entregar uma melhor experiência para nossos usuários. Essas informações são referentes logs de errors gerados pelo app, informações de 
            identificação do app para envio de notificações, além de informações para envio de anúncios personalizados.</p>
            <p> As informações disponibilizas no aplicativo são de uso informativo, não nos reponsabilizamos por qualquer interpretação que venha causar dano ao usuário.</p>
          </div>
        </div>

        <div>
          <p className='topic'>Compromisso do Usuário</p>
          <div className='text'>
            <p>O usuário se compromete a fazer uso adequado dos conteúdos e informações que o app Mês Bíblico disponibiliza.</p>
          </div>
        </div>
        <br/><br/>
        <p className='footer'> Esta política é efetiva a partir de Junho/2022.</p>
      </main>
    </div>
  );
}

export default App;
